export class AwsAccountMetricsDestination {
    'region';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsAccountMetricsDestination.attributeTypeMap;
    }
    constructor() {
    }
}
